
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utils/Util';
import DeviceTypeService from '@/services/DeviceTypeService';

  export default Vue.extend({
    name: 'DeviceTypeRestoreDialog',

    props: ['devicetype'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmRestore() {
        this.loading = true;
      
        DeviceTypeService.restoreDeviceType(this.devicetype.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('devicetype.successRestore') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("restore", this.devicetype);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('devicetype.errorRestore') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
